<template>
  <div class="m-nav">
    <i class="iconfont iconcaidan" @click="controlNav(true)"></i>
    <transition name="fade" mode="">
      <div class="menu" v-show="show">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          text-color="#516379"
          active-text-color="#35379F"
          router
        >
          <el-menu-item index="/" @click="controlNav(false)">
            <template #title>
              <span>首页</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/block" @click="controlNav(false)">
            <template #title>
              <span>查看区块</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/tradelist" @click="controlNav(false)">
            <template #title>
              <span>查看数据</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/token" @click="controlNav(false)">
            <template #title>
              <span>Token</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/alytx" @click="controlNav(false)">
            <template #title>
              <span>解析数据</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/broadtx" @click="controlNav(false)">
            <template #title>
              <span>广播数据</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </transition>
    <div class="bg" @click="controlNav(false)" v-show="show"></div>
  </div>
</template>

<script setup>
import { ref } from "vue";
let show = ref(false);

function controlNav(val, url) {
  show.value = val;
  if (url) window.open(url);
}
</script>

<style lang="scss">
.m-nav {
  position: relative;
  .iconcaidan {
    color: $font_grey;
  }
  .back {
    width: 99px;
    height: 31px;
    background: rgba(217, 167, 58, 1);
    border-radius: 18px;
    color: #fff;
    font-size: 14px;
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%);
  }
  .menu {
    height: 100vh;
    width: 145px;
    z-index: 200;
    position: fixed;
    top: 0;
    left: 0;
    background: $white;
  }
  .el-menu {
    border: none;
    .el-menu-item {
      text-indent: 1em;
      background-color: #fff;
      -webkit-tap-highlight-color: transparent;
    }
  }
  .bg {
    background: rgba(0, 0, 0, 0.44);
    position: fixed;
    z-index: 199;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s;
  }
  .fade-enter-from,
  .fade-leave-to {
    transform: translateX(-230px);
  }
}
</style>